
import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-[#1A1A1A] text-white">
      {/* Canadian Shoppers Banner */}
      <div className="bg-[#2D5F3F]/30 border-b border-[#D4AF37]/20">
        <div className="max-w-7xl mx-auto px-4 py-4 flex flex-col sm:flex-row items-center justify-between gap-3">
          <div className="flex items-center gap-3">
            <i className="ri-map-pin-line text-[#D4AF37] text-lg"></i>
            <p className="text-sm text-white/80">
              <strong className="text-white">Shopping from Canada?</strong> Visit our Canadian store for CAD pricing and local shipping.
            </p>
          </div>
          <a
            href="https://elixirsue.ca"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-2 bg-[#D4AF37] text-[#1A1A1A] px-5 py-2 rounded-full text-sm font-bold hover:bg-white transition-all duration-300 cursor-pointer whitespace-nowrap"
          >
            <i className="ri-external-link-line"></i>
            Visit elixirsue.ca (CAD)
          </a>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 py-12 md:py-20">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-12 mb-8 md:mb-12">
          <div className="col-span-1">
            <div className="flex items-center gap-3 mb-2">
              <img
                src="https://static.readdy.ai/image/175fc0d3a7deb119f46e9d68342e64a7/3dea3d651ee128006b12d110f2ad0b27.png"
                alt="Elixir Sue Logo"
                className="h-10 w-10 object-contain"
              />
              <div>
                <h3 className="text-2xl md:text-3xl font-bold leading-tight">Elixir Sue</h3>
                <span className="text-[10px] text-[#D4AF37] font-semibold tracking-widest uppercase">.com · International</span>
              </div>
            </div>
            <p className="text-sm text-[#F5F1E8] mb-2 mt-3">
              Global Cannabis Wellness Experts
            </p>
            <p className="text-xs text-gray-500 mb-6">
              All prices displayed in <strong className="text-[#D4AF37]">USD</strong>. We ship worldwide where legally permitted.
            </p>
            <div className="flex items-center gap-4 mb-6">
              <a
                href="https://instagram.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-12 h-12 flex items-center justify-center rounded-full border-2 border-[#D4AF37] text-[#D4AF37] hover:bg-[#D4AF37] hover:text-[#1A1A1A] transition-all duration-300 cursor-pointer"
              >
                <i className="ri-instagram-line text-xl"></i>
              </a>
              <a
                href="https://facebook.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-12 h-12 flex items-center justify-center rounded-full border-2 border-[#D4AF37] text-[#D4AF37] hover:bg-[#D4AF37] hover:text-[#1A1A1A] transition-all duration-300 cursor-pointer"
              >
                <i className="ri-facebook-fill text-xl"></i>
              </a>
              <a
                href="https://pinterest.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-12 h-12 flex items-center justify-center rounded-full border-2 border-[#D4AF37] text-[#D4AF37] hover:bg-[#D4AF37] hover:text-[#1A1A1A] transition-all duration-300 cursor-pointer"
              >
                <i className="ri-pinterest-fill text-xl"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-lg font-bold mb-4 md:mb-6">Shop</h4>
            <ul className="space-y-2 md:space-y-3">
              <li><Link to="/shop" className="text-sm text-gray-400 hover:text-[#D4AF37] transition-colors cursor-pointer">CBD Products</Link></li>
              <li><Link to="/shop" className="text-sm text-gray-400 hover:text-[#D4AF37] transition-colors cursor-pointer">Seeds</Link></li>
              <li><Link to="/shop" className="text-sm text-gray-400 hover:text-[#D4AF37] transition-colors cursor-pointer">Wellness</Link></li>
              <li><Link to="/shop" className="text-sm text-gray-400 hover:text-[#D4AF37] transition-colors cursor-pointer">Gift Cards</Link></li>
              <li><Link to="/shop" className="text-sm text-gray-400 hover:text-[#D4AF37] transition-colors cursor-pointer">All Products</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-bold mb-4 md:mb-6">Learn</h4>
            <ul className="space-y-2 md:space-y-3">
              <li><Link to="/blog" className="text-sm text-gray-400 hover:text-[#D4AF37] transition-colors cursor-pointer">Growing Guides</Link></li>
              <li><Link to="/blog" className="text-sm text-gray-400 hover:text-[#D4AF37] transition-colors cursor-pointer">Blog</Link></li>
              <li><Link to="/blog" className="text-sm text-gray-400 hover:text-[#D4AF37] transition-colors cursor-pointer">Pest Management</Link></li>
              <li><a href="#community" className="text-sm text-gray-400 hover:text-[#D4AF37] transition-colors cursor-pointer">Community</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-bold mb-4 md:mb-6">Get In Touch</h4>
            <ul className="space-y-3 md:space-y-4">
              <li className="flex items-center gap-3 text-sm text-gray-400">
                <i className="ri-mail-line text-[#D4AF37] text-lg"></i>
                <span>support@elixirsue.com</span>
              </li>
              <li className="flex items-center gap-3 text-sm text-gray-400">
                <i className="ri-phone-line text-[#D4AF37] text-lg"></i>
                <span>Worldwide support</span>
              </li>
              <li className="flex items-center gap-3 text-sm text-gray-400">
                <i className="ri-global-line text-[#D4AF37] text-lg"></i>
                <span>Serving customers globally</span>
              </li>
              <li className="flex items-start gap-3 text-sm text-gray-400 mt-2 pt-2 border-t border-gray-700">
                <i className="ri-map-pin-2-line text-[#D4AF37] text-lg mt-0.5"></i>
                <div>
                  <p className="text-white font-semibold text-xs mb-0.5">Canadian Store</p>
                  <a
                    href="https://elixirsue.ca"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-[#D4AF37] hover:underline cursor-pointer"
                  >
                    elixirsue.ca (CAD)
                  </a>
                </div>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-[#D4AF37]/30 pt-6 md:pt-8">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <p className="text-xs text-gray-500 text-center md:text-left">
              © 2025 Elixir Sue (elixirsue.com). All rights reserved. · Olds, Alberta, Canada
            </p>
            <div className="flex flex-wrap items-center justify-center gap-3 md:gap-6 text-center">
              <Link to="/privacy" className="text-xs text-gray-500 hover:text-[#D4AF37] transition-colors cursor-pointer whitespace-nowrap">Privacy Policy</Link>
              <span className="text-gray-700 hidden md:inline">|</span>
              <Link to="/terms" className="text-xs text-gray-500 hover:text-[#D4AF37] transition-colors cursor-pointer whitespace-nowrap">Terms of Service</Link>
              <span className="text-gray-700 hidden md:inline">|</span>
              <a href="#" className="text-xs text-gray-500 hover:text-[#D4AF37] transition-colors cursor-pointer whitespace-nowrap">Compliance</a>
              <span className="text-gray-700 hidden md:inline">|</span>
              <span className="text-xs text-gray-500 whitespace-nowrap">Must be of legal age in your jurisdiction. We only ship where legal.</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
